import type { ComponentPropsWithoutRef, ElementType } from 'react'

import { clsx } from 'clsx'

interface ProseOwnProps {
  as?: ElementType
  useMarkdocRenderer?: boolean
  isLandingPage?: boolean
}

type ProseProps = ProseOwnProps & Omit<ComponentPropsWithoutRef<'div'>, keyof ProseOwnProps>

export function Prose({ as: Component = 'div', className = '', useMarkdocRenderer = false, isLandingPage = false, ...extraProps }: ProseProps): JSX.Element {
  return (
    <Component
      className={clsx(
        className,
        'prose prose-portal max-w-none dark:prose-invert text-(--sp-color-text)',
        useMarkdocRenderer ? 'pb-7' : isLandingPage ? 'pb-0' : 'pb-12',
        // headings
        'prose-headings:scroll-mt-6 prose-headings:font-display prose-headings:font-normal lg:prose-headings:scroll-mt-[1.5rem]',
        // lead
        'prose-lead:text-(--sp-color-text)',
        // links
        'prose-a:text-(--sp-color-link) prose-a:hover:text-(--sp-color-link-hover)',
        // pre
        'prose-pre:rounded prose-pre:mx-6 prose-pre:bg-portal-900 dark:prose-pre:bg-portal-800/60 dark:prose-pre:ring-1 dark:prose-pre:ring-slate-300/10',
        // hr
        'prose-hr:border-(--sp-color-border-subtle)',
        // paragraphs
        'prose-p:text-body1',
        
        // TABLE
        'prose-table:w-auto prose-table:border-collapse prose-table:border-(--sp-color-border-subtle) prose-table:text-body2',
        // thead
        'prose-thead:border-b-2 prose-thead:border-(--sp-color-border-subtle) prose-thead:align-middle',
        // th
        'prose-th:font-bold prose-th:text-left prose-th:py-2.5 prose-th:px-3 prose-th:bg-(--sp-color-surface-hover) prose-th:border-r-1 prose-th:last:border-r-0 prose-th:border-(--sp-color-border-subtle)',
        // td
        'prose-td:py-2.5 prose-td:px-3 prose-td:align-middle prose-td:border-r-1 prose-td:last:border-r-0 prose-td:border-(--sp-color-border-subtle)',
        // tr
        'prose-tr:border-b-1 prose-tr:border-(--sp-color-border-subtle) prose-tr:odd:bg-(--sp-color-surface-sunken)',
        // paragraphs
        '[&_table_p]:text-body2 [&_table_p]:my-0',
        // quotes
        '[&_table_blockquote_p]:text-body3 [&_table_blockquote]:mt-2 [&_table_blockquote]:mb-0 [&_table_blockquote]:border-(--sp-color-border)',
        // inline code
        '[&_:not(pre)>code]:bg-(--sp-color-surface-hover) [&_:not(pre)>code]:rounded [&_:not(pre)>code]:px-1.5 [&_:not(pre)>code]:py-0.5'
      )}
      {...extraProps}
    />
  )
}